// src/services/homeFeedScore.ts
//
// Ana ev-feed (Feed.tsx) için CLIENT-SIDE sıralama skoru — SAF fonksiyonlar
// (Firebase'siz, birim-test edilebilir). Yalnız item üzerinde HALİHAZIRDA
// mevcut alanları kullanır; ekstra okuma/denorm GEREKTİRMEZ.
//
// PR-40 — LEGACY LIKE SİNYALİ RANKING'DEN KALDIRILDI. Eski yorum yanlıştı:
// `begenenler` array'i 5★ değil, PR-29'da kaldırılan İKİLİ BEĞENİ array'iydi
// (artık yeni yazım YOK → veri DONMUŞ). Kilitli ürün kuralı: kalp/like sosyal
// kalite sinyali DEĞİLDİR → sıralamayı ETKİLEMEZ. Bu yüzden engagement
// skorundan çıkarıldı (nötr). Kalan sinyaller: post yorum sayısı +
// clip server boost (v3_score). 5★'ı ranking'e YENİ ağırlık olarak bağlamak
// AYRI/bilinçli bir Star Engine kararıdır — bu PR'da YAPILMAZ. Rating
// ortalaması yine skora dahil DEĞİL (content/{id} ayrı doc; ekstra okuma yok).
// `begenenler` alanı interface'te bırakıldı (rename/silme yok) ama OKUNMUYOR.

export interface HomeFeedItem {
  id?: string;
  // ⚠️ Üç alan GENİŞLETİLDİ — gerekçe bu dosyanın KENDİ gövdesinde:
  //   `type`     → yalnız `it.type === "clip"` karşılaştırılıyor (89);
  //                veri tarafında serbest metin (Explore'da post `type`i
  //                Firestore'dan geliyor). Union, veriyi yalanlıyordu.
  //   `authorId` → Explore adaptörü `c.authorId || null` üretiyor (196).
  //   `v3_score` → okuma zaten `typeof … === "number"` guard'lı (91).
  // Daraltma "daha güvenli" değildi; çağıranı tipini kaybetmeye zorluyordu.
  type?: string | null;
  authorId?: string | null;
  tarih?: any;
  // `unknown[]` → `unknown`: TEK okuyucu `arrLen(v: unknown)` (87) ve o
  // zaten `Array.isArray` ile süzüyor. Dizi olduğunu İDDİA etmek, veriyi
  // (Firestore alanı hiç olmayabilir / dizi olmayabilir) yalanlıyordu.
  begenenler?: unknown;
  yorumlar?: unknown;
  v3_score?: unknown;
  engagementScore?: number;
  // Explore: caption metni (#etiket çıkarımı için).
  mesaj?: string;
  aciklama?: string;
  caption?: string;
}

export interface ScoreOpts {
  nowMs: number;
  ownUid?: string | null;
  // uid → takip sırasındaki index (0 = en yeni takip). Yakınlık proxy'si.
  followingOrder?: Map<string, number>;
  followCount?: number;
  // Explore kişiselleştirme: viewer'ın takip ettiği/ilgilendiği hashtag'ler
  // (lowercase slug). Item caption'ındaki #etiketlerle kesişim → boost.
  interestTags?: Set<string>;
}

// ── Ayarlanabilir ağırlıklar (deploy gerektirmez; istenirse override) ──
export const TAU_HOURS = 48; // recency yarı-ömrü ~33s
export const BASE = 1;
export const W_ENG = 0.6;
export const AFFINITY_W = 0.25;
export const OWN_BONUS = 0.15;
export const INTEREST_BOOST = 1.18; // ilgi-etiketi eşleşen içerik çarpanı

const log1p = (n: number) => Math.log(1 + Math.max(0, n));

const HASHTAG_RE = /#([\p{L}0-9_]+)/gu;
/** Item caption'ından lowercase hashtag slug'larını çıkarır. */
export function extractHashtags(it: HomeFeedItem): string[] {
  const text = String(it?.mesaj || it?.aciklama || it?.caption || "");
  if (!text || text.indexOf("#") === -1) return [];
  const out: string[] = [];
  let m: RegExpExecArray | null;
  HASHTAG_RE.lastIndex = 0;
  while ((m = HASHTAG_RE.exec(text)) !== null) {
    if (m[1]) out.push(m[1].toLowerCase());
  }
  return out;
}

/** Item'ın tarihini saniyeye çevirir (optimistic null → şimdi). */
export function itemSeconds(it: HomeFeedItem, nowMs: number): number {
  // 🐞 BUGGIFY · i-feed-tarihi-gelecekte — ÖĞEYİ GELECEĞE TARİHLE.
  // Taklit edilen GERÇEK arıza: `tarih` sunucu saatiyle yazılır, `nowMs`
  // İSTEMCİ saatidir; kayarsa (kullanıcı saati ileri, TZ/DST hatası) yaş
  // NEGATİF olur. SINANAN ONARIM: `Math.max(0, ...)` yaş kırpması ve
  // `Math.exp(-ageHours/TAU)` — skor sonlu kalmalı, sıralama patlamamalı
  // ve akış BOŞALMAMALI. ⚙️ Üretimde derleme zamanı elenir.
  if (process.env.REACT_APP_BUGGIFY === "1" && window.__vwBuggify?.("i-feed-tarihi-gelecekte")) return (nowMs + 72 * 3600 * 1000) / 1000;
  const t: any = it && it.tarih;
  if (!t) return nowMs / 1000;
  if (typeof t.seconds === "number") return t.seconds;
  if (t instanceof Date) return t.getTime() / 1000;
  if (typeof t === "string") {
    const ms = new Date(t).getTime();
    return Number.isFinite(ms) ? ms / 1000 : nowMs / 1000;
  }
  return nowMs / 1000;
}

const arrLen = (v: unknown): number => (Array.isArray(v) ? v.length : 0);

/** Tek item için sıralama skoru (yüksek = üstte). Saf. */
export function scoreItem(it: HomeFeedItem, opts: ScoreOpts): number {
  if (!it) return 0;
  // 🐞 BUGGIFY · i-feed-skoru-sonsuz — SKORU NaN/Infinity YAP.
  // Taklit edilen GERÇEK arıza: skor denorm etkileşim alanlarını çarpıyor;
  // biri `undefined`/string olursa (migre edilmemiş belge, kısmi tetikleyici
  // yazımı) çarpım NaN'a düşer. SINANAN ONARIM: `sortHomeFeed` NaN
  // karşılaştırmasında öğe DÜŞÜRMEMELİ/ÇOĞALTMAMALI ve tüketici NaN skoru
  // ekrana basmamalı — akış yine dolu render edilmeli.
  // ⚙️ Üretimde derleme zamanı elenir (`false && …` → Terser bloğu siler).
  if (process.env.REACT_APP_BUGGIFY === "1" && window.__vwBuggify?.("i-feed-skoru-sonsuz")) return Number.NaN;
  const nowSec = opts.nowMs / 1000;
  const ageHours = Math.max(0, (nowSec - itemSeconds(it, opts.nowMs)) / 3600);
  const recencyDecay = Math.exp(-ageHours / TAU_HOURS);

  const isClip = it.type === "clip";
  const clipServerBoost = isClip
    ? typeof it.v3_score === "number"
      ? it.v3_score
      : typeof it.engagementScore === "number"
        ? it.engagementScore
        : 0
    : 0;

  // post inline yorum sinyali kullanılır; clip yorumu subcollection'a taşındığı
  // için (clip.yorumlar güvenilmez) clip'te yorum sinyali YOK.
  const commentSignal = !isClip ? 0.5 * log1p(arrLen(it.yorumlar)) : 0;

  // PR-40 — begenenler (donmuş legacy like verisi) ARTIK skora GİRMEZ.
  const engagement = commentSignal + clipServerBoost;

  let authorAffinity = 1;
  const uid = it.authorId;
  if (uid && opts.followingOrder && opts.followingOrder.has(uid)) {
    const rank = opts.followingOrder.get(uid) as number;
    const fc = Math.max(1, opts.followCount || opts.followingOrder.size || 1);
    authorAffinity = 1 + AFFINITY_W * (1 - Math.min(1, rank / fc));
  }
  if (uid && opts.ownUid && uid === opts.ownUid) {
    authorAffinity += OWN_BONUS;
  }

  // Explore ilgi-eşleşmesi: caption #etiketi viewer'ın ilgi setindeyse boost.
  let interestBoost = 1;
  if (opts.interestTags && opts.interestTags.size) {
    const tags = extractHashtags(it);
    for (let i = 0; i < tags.length; i++) {
      if (opts.interestTags.has(tags[i])) { interestBoost = INTEREST_BOOST; break; }
    }
  }

  return recencyDecay * (BASE + W_ENG * engagement) * authorAffinity * interestBoost;
}

/**
 * Item dizisini skora göre sıralar (yeni dizi döndürür; girdi mutasyona
 * uğramaz). Skor eşitse tarih desc tie-breaker.
 */
// 🧭 Jenerik: bu fonksiyon YENİ nesne üretmiyor, verilenleri yeniden
// sıralıyor. Dönüşü `HomeFeedItem[]`e sabitlemek, çağıranın kendi öğe
// tipini kaybettiriyordu (Explore'da `KesfetOgesi[]` → `HomeFeedItem[]`).
// `T extends HomeFeedItem` hem girdiyi hem çıktıyı doğru anlatır; mevcut
// `HomeFeedItem[]` çağrıları aynen çalışır.
export function sortHomeFeed<T extends HomeFeedItem>(items: T[], opts: ScoreOpts): T[] {
  // 🐞 BUGGIFY · i-feed-skorlari-esit — TÜM SKORLARI EŞİTLE.
  // Taklit edilen GERÇEK arıza: skor `createdAt` (recency) ve denorm etkileşim
  // alanlarına dayanır. Yeni yazılan belgede `serverTimestamp()` sunucuya
  // inene kadar YEREL olarak `null`dur, denorm sayaçlar da tetikleyici
  // gecikirse 0 kalır → o pencerede BÜTÜN öğeler aynı skoru alır. SINANAN
  // ONARIM: sıralama bu hâlde bile öğe DÜŞÜRMEMELİ, ÇOĞALTMAMALI, akış boş
  // kalmamalı (dünyanın içerik-sayımı ve "ekran dolu" ölçütleri bunu görür).
  // ⚙️ Üretimde derleme zamanı elenir (`false && …` → Terser bloğu siler).
  const duz = process.env.REACT_APP_BUGGIFY === "1" && window.__vwBuggify?.("i-feed-skorlari-esit");
  const scored = items.map((it) => ({
    it,
    s: duz ? 0 : scoreItem(it, opts),
    t: duz ? 0 : itemSeconds(it, opts.nowMs),
  }));
  scored.sort((a, b) => (b.s - a.s) || (b.t - a.t));
  return scored.map((x) => x.it);
}

/** takipEdilenler dizisinden uid→index Map'i kurar (yakınlık için). */
export function buildFollowingOrder(takipEdilenler: string[]): Map<string, number> {
  const m = new Map<string, number>();
  if (Array.isArray(takipEdilenler)) {
    takipEdilenler.forEach((uid, i) => {
      if (uid && !m.has(uid)) m.set(uid, i);
    });
  }
  return m;
}
